jQuery(function($){

	blockSlider();
	rwdMenu();
    inifFancybox();
	goTo();
    showSearchForm();

    function showSearchForm() {
        $('.site-header__search').click(function(e) {
            e.preventDefault();
            $('.search-form').slideToggle(500);
        });
    }

	function goTo() {

    $(".go-to").click(function(event) {
        event.preventDefault();
        var href = $(this).attr('href');
        var pos = -100;
        jQuery('html, body').animate({
            scrollTop: jQuery(href).offset().top + pos
        }, 500);
        });
    }

    function inifFancybox() {
        Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        loop : true,

        afterClose: function(instance, current) {
            var videos = document.querySelectorAll('.inline-movies');

            videos.forEach(function(video) {
                video.pause();
            });
        }
        });
    }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1024) {

			$('.site-header__navigation .menu-item-has-children > a').on('click', function(event) {
				event.stopPropagation();
				$(this).parent('li').children('ul').slideToggle(300);
				$(this).parent('li').toggleClass('active');
			});
			
			$('.menu-item-has-children').on('click', function(event) {
				if (!$(event.target).is('a')) {
					event.stopPropagation();
					$(this).children('ul').slideToggle(300);
					$(this).toggleClass('active');
				}
			});
		}
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {

			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;

			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	    });
	}());

    $(window).scroll(function() {   
        var windowWidth = $(window).width();
        var scroll = $(window).scrollTop();

        if (scroll >= 250 ) {
            $("header").addClass("scrolled");
        
        } else {
            $("header").removeClass("scrolled");
        }

    });

	function blockSlider() {

		jQuery('.header-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
			singleItem: true,
			navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M47.5 44C47.5 45.933 45.933 47.5 44 47.5L2 47.5C1.17157 47.5 0.5 46.8284 0.5 46L0.500004 2C0.500004 1.17157 1.17158 0.499996 2 0.499996L44 0.5C45.933 0.5 47.5 2.06701 47.5 4L47.5 44Z" stroke="white"/><path d="M28.666 24L19.3327 24" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.666L19.3333 23.9993L24 19.3327" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H46C46.8284 0.5 47.5 1.17157 47.5 2V46C47.5 46.8284 46.8284 47.5 46 47.5H4C2.067 47.5 0.5 45.933 0.5 44V4Z" stroke="white"/><path d="M19.334 24H28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.334L28.6667 24.0007L24 28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
			autoplayHoverPause:true
		});

        jQuery('.partners-slider').owlCarousel({
            loop:true,
            margin:32,
            nav:true,
            items:1,
            autoplay:true,
            autoplayTimeout:4000,
            autoplaySpeed: 1700,
            slideSpeed: 1700,
            navSpeed: 1700,
            dotsSpeed: 1700,
            dots: false,
            singleItem: true,
            stagePadding: 100,
            navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48 44C48 46.2091 46.2091 48 44 48L2 48C0.895432 48 7.8281e-08 47.1046 1.74846e-07 46L4.02145e-06 2C4.11801e-06 0.895427 0.895436 -4.11801e-06 2 -4.02145e-06L44 -3.49691e-07C46.2091 -1.56562e-07 48 1.79086 48 4L48 44Z" fill="#F6F6FB"/><path d="M28.666 24L19.3327 24" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.667L19.3333 24.0003L24 19.3337" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4C0 1.79086 1.79086 0 4 0H46C47.1046 0 48 0.895431 48 2V46C48 47.1046 47.1046 48 46 48H4C1.79086 48 0 46.2091 0 44V4Z" fill="#F6F6FB"/><path d="M19.334 24H28.6673" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.333L28.6667 23.9997L24 28.6663" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
            responsive:{
                0:{
                items:1,
                },
                960:{
                items:2,
                },
                1100:{
                items:3,
                },
                1240:{
                items:4,
                },
                1440:{
                    items:5,
                },
                1900:{
                    items:6,
                },
                
            }
        });
    }

})